const ProductIngredientsLegacy = class extends HTMLElement {
  constructor () {
    super()

    this.legacyIngredientsList = this.querySelector('[data-legacy-product-ingredients]')
    this.restructuredIngredientsList = this.querySelector('[data-legacy-product-ingredients-restructured]')
    this.legacyEquipmentList = this.querySelector('[data-legacy-product-equipment]')
    this.restructuredEquipmentList = this.querySelector('[data-legacy-product-equipment-restructured]')
    this.ingredientGroups = this.querySelectorAll('[data-product-ingredients-group]')
    this.totalPriceEl = this.querySelector('[data-product-ingredients-total-price]')
    this.totalQuantityEl = this.querySelector('[data-product-ingredients-total-quantity]')
    this.atcButton = this.querySelector('[data-product-ingredients-atc]')
    this.atcText = this.querySelector('[data-product-ingredients-atc-text]')
    this.atcTextSingle = this.querySelector('[data-product-ingredients-atc-text-single]')

    this.initLegacyRestructure()

    setTimeout(() => {
      this.productCheckboxes = this.querySelectorAll('[data-product-ingredients-checkbox]')
      this.initIngredients()
      this.stickyIngredients()
    }, 1000);
  }

  /**
   * Restructures legacy ingredients/equipment lists
   */
  initLegacyRestructure () {
    if (this.legacyIngredientsList) {
      const listItems = this.legacyIngredientsList.querySelectorAll('li')

      listItems.forEach(async (listItem, index) => {
        if (listItem.hasAttribute('data-product')) {
          const productHandle = listItem.getAttribute('data-product')
          const productData = await (await fetch(`${Shopify.routes.root}products/${productHandle}.js`)).json()
          const productPrice = `$${(productData.price / 100).toFixed(2)}`

          this.restructuredIngredientsList.insertAdjacentHTML('beforeend', `
            <div class="product-ingredients__product">
              <input class="sr-only"
                type="checkbox"
                name="${productData.title}"
                id="ingredient-${index}--${productHandle}"
                autocomplete="off"
                data-product-ingredients-checkbox
                data-product-ingredients-product-variant-id="${productData.variants[0].id}"
                data-product-ingredients-product-price="${productData.price}"
                data-product-ingredients-product-quantity="1"
                ${productData.available ? '' : 'disabled'}>
              <label for="ingredient-${index}--${productHandle}">
                <span class="product-ingredients__product-title">
                  ${listItem.innerHTML}
                </span>
                ${productData.available ? (
                  `<span class="product-ingredients__product-price">${productPrice}</span>`
                ) : (
                  '<span class="product-ingredients__product-price">Sold Out</span>'
                )}
              </label>
            </div>
          `)
        } else {
          this.restructuredIngredientsList.insertAdjacentHTML('beforeend', `
            <p class="product-ingredients__home-ingredient">
              ${listItem.innerHTML}
            </p>
          `)
        }
      })
    }

    if (this.legacyEquipmentList) {
      const listItems = this.legacyEquipmentList.querySelectorAll('li')

      listItems.forEach(async (listItem, index) => {
        if (listItem.hasAttribute('data-product')) {
          const productHandle = listItem.getAttribute('data-product')
          const productData = await (await fetch(`${Shopify.routes.root}products/${productHandle}.js`)).json()
          const productPrice = `$${(productData.price / 100).toFixed(2)}`

          this.restructuredEquipmentList.insertAdjacentHTML('beforeend', `
            <div class="product-ingredients__product">
              <input class="sr-only"
                type="checkbox"
                name="${productData.title}"
                id="ingredient-${index}--${productHandle}"
                autocomplete="off"
                data-product-ingredients-checkbox
                data-product-ingredients-product-variant-id="${productData.variants[0].id}"
                data-product-ingredients-product-price="${productData.price}"
                data-product-ingredients-product-quantity="1"
                ${productData.available ? '' : 'disabled'}>
              <label for="ingredient-${index}--${productHandle}">
                <span class="product-ingredients__product-title">
                  ${listItem.innerHTML}
                </span>
                ${productData.available ? (
                  `<span class="product-ingredients__product-price">${productPrice}</span>`
                ) : (
                  '<span class="product-ingredients__product-price">Sold Out</span>'
                )}
              </label>
            </div>
          `)
        } else {
          this.restructuredEquipmentList.insertAdjacentHTML('beforeend', `
            <p class="product-ingredients__home-ingredient">
              ${listItem.innerHTML}
            </p>
          `)
        }
      })
    }
  }

  /**
   * Initializes all functionality
   */
  initIngredients () {
    if (this.ingredientGroups.length > 0) {
      this.selectAll()
    }

    this.checkboxListeners()
    this.atcListener()
    this.calculateTotals()
  }

  /**
   * Check if ingredients fit in viewport, add sticky styles
   */
  stickyIngredients () {
    if ((this.offsetHeight + 100) <= window.innerHeight) {
      this.parentElement.classList.add('product-recipe__ingredients--sticky')
    }
  }

  /**
   * Selects/deselects all checkboxes in item group
   */
  selectAll () {
    this.ingredientGroups.forEach((ingredientGroup) => {
      const selectAllTrigger = ingredientGroup.querySelector('[data-product-ingredients-select-all]')

      if (!selectAllTrigger) { return }

      const groupCheckboxes = ingredientGroup.querySelectorAll('[data-product-ingredients-checkbox]:not([disabled])')

      selectAllTrigger.addEventListener('click', () => {
        groupCheckboxes.forEach((groupCheckbox) => {
          groupCheckbox.checked = selectAllTrigger.checked
        })

        this.calculateTotals()
      })
    })
  }

  /**
   * Sets up checkbox listeners, calculate total on change
   */
  checkboxListeners () {
    this.productCheckboxes.forEach((productCheckbox) => {
      productCheckbox.addEventListener('change', () => {
        if (!productCheckbox.checked) {
          const ingredientGroup = productCheckbox.closest('[data-product-ingredients-group]')
          const selectAll = ingredientGroup.querySelector('[data-product-ingredients-select-all]')

          selectAll.checked = false
        }
        this.calculateTotals()
      })
    })
  }

  /**
   * Sets up ATC listener, formats selected items
   */
  atcListener () {
    this.atcButton.addEventListener('click', () => {
      const selectedProducts = this.querySelectorAll('[data-product-ingredients-checkbox]:checked')
      const formData = {
        items: []
      }

      selectedProducts.forEach((selectedProduct) => {
        formData.items.push({
          id: selectedProduct.dataset.productIngredientsProductVariantId,
          quantity: parseInt(selectedProduct.dataset.productIngredientsProductQuantity, 10)
        })
      })

      this.addProducts(formData)
    })
  }

  /**
   * Adds items to cart
   * @param {object} formData : object of items to add to cart
   */
  async addProducts (formData) {
    const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
      body: JSON.stringify(formData),
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json'
      }
    })
    const responseJson = await response.json()

    if (response.ok) {
      if (window.themeVariables.settings.cartType === 'page' || window.themeVariables.settings.cartType === 'popover' || window.themeVariables.settings.pageType === 'cart') {
        return window.location.href = `${Shopify.routes.root}cart`
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json()
      cartContent['sections'] = responseJson['sections']

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent
        }
      }))
    } else {
      this.dispatchEvent(new CustomEvent('cart:error', {
        bubbles: true,
        detail: {
          error: responseJson['description']
        }
      }))
    }
  }

  /**
   * Calculates total quantity and price of selected items
   */
  calculateTotals () {
    const selectedProducts = this.querySelectorAll('[data-product-ingredients-checkbox]:checked')
    const totalPrice = Array.from(selectedProducts).reduce((total, item) =>
      total + parseInt(item.dataset.productIngredientsProductPrice, 10)
    , 0)
    const totalQuantity = Array.from(selectedProducts).reduce((total, item) =>
      total + parseInt(item.dataset.productIngredientsProductQuantity, 10)
    , 0)

    this.totalPriceEl.innerHTML = `$${(totalPrice / 100).toFixed(2)}`
    this.totalQuantityEl.innerHTML = totalQuantity
    this.atcButton.toggleAttribute('disabled', totalQuantity < 1)
    this.atcText.classList.toggle('hidden', totalQuantity === 1)
    this.atcTextSingle.classList.toggle('hidden', totalQuantity !== 1)
  }
}

if (typeof window.customElements.get('product-ingredients-legacy') === 'undefined') {
  window.customElements.define('product-ingredients-legacy', ProductIngredientsLegacy)
}
